import { colors } from 'theme'

export const defaultThemeScheduleStyles = {
    'step': colors.darkCloud,
    'active-step': colors.darkBlue,
    'stepBorder': colors.cloud
}
